// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__ox7Vw","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3NYoH","obliqueLine":"membershipbadge_obliqueLine__HqcOQ"};